import * as React from "react";
import Header from "../../../components/Header";
import { SimpleTextPhase } from "../../../components/SimpleTextPhase";
export default function BaseForgotPasswordRoute(_a) {
    var issuer = _a.issuer;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(SimpleTextPhase, { title: "Forgot Your Password?" },
            React.createElement("p", { className: "cursor-default text-center text-lg" }, "To regain access to your account, please visit your provider's website:"),
            React.createElement("p", { className: "text-center" },
                React.createElement("a", { href: issuer.site, className: "text-trellis-black underline", rel: "noopener noreferrer", target: "_blank" }, issuer.site)))));
}
